import { create } from "zustand";

interface ITrendingCreatorsState {
  ids: string[];
  setIds: (ids: string[]) => void;
}

export const useTendingCreatorsStore = create<ITrendingCreatorsState>(
  (set) => ({
    ids: [],
    setIds: (ids: string[]) => {
      set(() => ({ ids }));
    },
  }),
);
